package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.ui.graphics.Color

/**
 * Deterministic per-identity avatar color: the same person is always the same hue everywhere
 * (people cards, map markers, inbox rows, feed avatars), and a crowd of initials reads as a lively
 * mix instead of a wall of one teal. Fixed brand-adjacent palette — decorative fills with white
 * initials on top, deliberately theme-independent (like map overlay colors).
 */
fun avatarColorFor(seed: String): Color = AVATAR_PALETTE[
    seed.fold(0) { acc, c -> (acc * 31 + c.code) and 0x7fffffff } % AVATAR_PALETTE.size
]

private val AVATAR_PALETTE = listOf(
    Color(0xFF00838F), // deep cyan
    Color(0xFF6A4FA3), // violet
    Color(0xFFB4632C), // copper
    Color(0xFF2E7D5B), // pine
    Color(0xFFAD1F5C), // raspberry
    Color(0xFF3D6DB5), // cobalt
    Color(0xFF8C6D1F), // ochre
    Color(0xFF5E7C16), // olive
)
